import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const DownloadFileIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <defs>
        <polygon id="path-1" points="0 0 24.6525 0 24.6525 30.489 0 30.489"></polygon>
      </defs>
      <g fill="none" fillRule="evenodd" id="Download_icon" stroke="none" strokeWidth="1">
        <g id="icon" transform="translate(4.000000, 1.000000)">
          <path
            d="M3.1727,29.4888 C1.9747,29.4888 0.9997,28.4088 0.9997,27.0808 L0.9997,3.4088 C0.9997,2.0808 1.9747,0.9998 3.1727,0.9998 L15.2227,0.9998 C15.7547,0.9998 16.2667,1.2148 16.6647,1.6038 L22.9237,7.7548 C23.3867,8.2098 23.6527,8.8668 23.6527,9.5578 L23.6527,27.0808 C23.6527,28.4088 22.6777,29.4888 21.4797,29.4888 L3.1727,29.4888 Z"
            fill="#ffffff"
            className={styles.white}
            id="Fill-1"
          ></path>
          <g id="Group-5">
            <mask fill="white" id="mask-2">
              <use xlinkHref="#path-1"></use>
            </mask>
            <g id="Clip-4"></g>
            <path
              d="M15.2225,0 L3.1725,0 C1.4235,0 -0.0005,1.529 -0.0005,3.409 L-0.0005,27.081 C-0.0005,28.96 1.4235,30.489 3.1725,30.489 L21.4795,30.489 C23.2295,30.489 24.6525,28.96 24.6525,27.081 L24.6525,9.558 C24.6525,8.601 24.2775,7.683 23.6245,7.041 L17.3665,0.892 C16.7815,0.317 16.0195,0 15.2225,0 M15.2225,2 C15.4935,2 15.7555,2.113 15.9655,2.319 L22.2225,8.468 C22.4945,8.735 22.6525,9.135 22.6525,9.558 L22.6525,27.081 C22.6525,27.859 22.1275,28.489 21.4795,28.489 L3.1725,28.489 C2.5255,28.489 1.9995,27.859 1.9995,27.081 L1.9995,3.409 C1.9995,2.631 2.5255,2 3.1725,2 L15.2225,2"
              fill="#00000"
              className={styles.defaultColor}
              id="Fill-3"
              mask="url(#mask-2)"
            ></path>
          </g>
          <path
            d="M15.6409,2 L15.6409,7.809 C15.6409,8.406 16.1249,8.89 16.7229,8.89 L22.6529,8.89"
            id="Stroke-6"
            stroke="#000000"
            className={styles.defaultStrokeColor}
          ></path>
          <g id="Group-6" transform="translate(7.192200, 9.506300)">
            <line
              id="Stroke-8"
              stroke="#0050B3"
              className={styles.interactiveStrokeColor}
              strokeLinecap="round"
              strokeWidth="2"
              x1="4.6821"
              x2="4.6821"
              y1="8.585"
              y2="0"
            ></line>
            <polyline
              fill="#0050B3"
              className={styles.interactiveColor}
              id="Fill-10"
              points="0.7803 7.2842 8.5843 7.2842 4.6823 12.4862"
            ></polyline>
            <line
              id="Stroke-12"
              stroke="#0050B3"
              className={styles.interactiveStrokeColor}
              strokeLinecap="round"
              strokeWidth="2"
              x1="0"
              x2="9.365"
              y1="14.0479"
              y2="14.0479"
            ></line>
          </g>
        </g>
      </g>
    </Icon>
  )
}
